/*eslint-disable*/
import React, { useState, useEffect } from "react";
import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  Button,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";


export default function Footer() {
  const [companyName, setCompanyName] = useState("Your Company");

  useEffect(() => {
    const userData = localStorage.getItem("user");
    // console.log("User Data bhai",userData);
    if (userData) {
      const user = JSON.parse(userData);
      if (user.companyName) {
        setCompanyName(user.companyName);
      }
    }
  }, []);

  const textColor = useColorModeValue("gray.400", "white");
  const { toggleColorMode } = useColorMode();
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px={{ base: "30px", md: "50px" }}
      pb='30px'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        {" "}
       
        <Text as='span' fontWeight='500' ms='4px'>
          <Link
            mx='3px'
            color={textColor}
            href='https://prowesserp.com/'
            target='_blank'>
            Powered By
          </Link> 
           &copy; 
          <Link
            mx='3px'
            color={textColor}
            href='https://prowesserp.com/'
            target='_blank'>
            Innovative Informatics Pvt. Ltd.
          </Link> 
        </Text>
      </Text>

       <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        {" "}
       
        <Text as='span' fontWeight='500' ms='4px'>
          <Link
            mx='3px'
            color={textColor}
            >
            License To
          </Link> 
          <Link
            mx='3px'
            color={textColor}
>
            {companyName}
          </Link> 
        </Text>
      </Text>
    </Flex>
  );
}
